// 首页全部请求（不包括三个查询）
import environment from '../../config/environment'
import {getRecommendedReadingAPI} from '../api'
import {encrypt} from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey

// 推荐阅读列表及轮播图列表
export function getRecommendedReading (payLoad) {
    const param = JSON.stringify({
        type: payLoad.type.toString(),
        start: 0,
        limit: 4
    })
    const params = qs.stringify({
        code: API_CODE,
        token: payLoad.token,
        param: encrypt(param, API_CODE, API_KEY)
    })
    return getRecommendedReadingAPI(params)
}



// WEBPACK FOOTER //
// ./src/request/index/index.js